
// Assign globals
window.$ = window.jQuery = require('jquery');
window.$ = $.extend(require('jquery-ui'));
